<template>
 <div class="bump">

    <v-data-table
      :headers="market"
      :items="timemd"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="rnd"
      :items="timerd"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="reg"
      :items="timercl"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="admin"
      :items="timemna"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="ssr"
      :items="timessr"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="tc"
      :items="totalCost"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="tcc"
      :items="totalCostCont"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
  <br>
</div>
</template>

<script>
export default {
  data() {
    return {
      market: [
        {
          text: 'Market Development Costs',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      rnd: [
        {
          text: 'R & D - Technical Design and Development',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      reg: [
        {
          text: 'Regulatory, Compliance & Legal',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      admin: [
        {
          text: 'Total Management & Admin',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      ssr: [
        {
          text: 'Total Services & Supplies Reserve',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      tc: [
        {
          text: 'Total Costs',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      tcc: [
        {
          text: 'Total Costs with Contingency (+10%)',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],//End Headers
      timemd: [
        {
          value: false,
          name: 'Personnel (Salaries)',
          notes: '',
          one: '$380,160.00',
          two: '$418,176.00',
          three: '$459,993.60',
          four: '$505,992.96',
          five: '$556,592.26'
        },
        {
          value: false,
          name: 'Advertising & Marketing',
          notes: '',
          one: '$438,000.00',
          two: '$438,000.00',
          three: '$438,000.00',
          four: '$438,000.00',
          five: '$438,000.00'
        },
        {
          value: false,
          name: 'PR Expenses',
          notes: '',
          one: '$72,000.00',
          two: '$72,000.00',
          three: '$72,000.00',
          four: '$72,000.00',
          five: '$72,000.00'
        },
        {
          value: false,
          name: 'Event + Travel Costs',
          notes: '',
          one: '$219,000.00',
          two: '$219,000.00',
          three: '$219,000.00',
          four: '$219,000.00',
          five: '$219,000.00'
        },
        {
          value: false,
          name: 'Community Management (Moderation & forum posters)',
          notes: '',
          one: '$18,000.00',
          two: '$18,000.00',
          three: '$18,000.00',
          four: '$18,000.00',
          five: '$18,000.00'
        },
        {
          value: false,
          name: 'Professional Services (MLG)',
          notes: '',
          one: '$240,000.00',
          two: '0',
          three: '0',
          four: '0',
          five: '0'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$1,367,160.00',
          two: '$1,165,176.00',
          three: '$1,206,993.60',
          four: '$1,252,992.96',
          five: '$1,303,592.26'
        }
      ],
      //Research and Development Costs
      timerd: [
        {
          value: false,
          name: 'Blockchain Advisor, Lead Architect',
          notes: '',
          one: '$155,000.00',
          two: '$120,000.00',
          three: '$120,000.00',
          four: '$120,000.00',
          five: '$120,000.00'
        },
        {
          value: false,
          name: 'Distributed Storage Advisor',
          notes: '',
          one: '$59,000.00',
          two: '$12,000.00',
          three: '$12,000.00',
          four: '$12,000.00',
          five: '$12,000.00'
        },
        {
          value: false,
          name: 'Economic Advisor',
          notes: '',
          one: '$65,000.00',
          two: '$10,000.00',
          three: '$10,000.00',
          four: '$10,000.00',
          five: '$10,000.00'
        },
        {
          value: false,
          name: 'Cryptographic (Maths) Advisor',
          notes: '',
          one: '$80,000.00',
          two: '$72,000.00',
          three: '$72,000.00',
          four: '$72,000.00',
          five: '$72,000.00'
        },
        {
          value: false,
          name: 'Semantics (Ontology) Advisor (contingency)',
          notes: '',
          one: '$85,000.00',
          two: '$48,000.00',
          three: '$48,000.00',
          four: '$48,000.00',
          five: '$48,000.00'
        },
        {
          value: false,
          name: 'Market Research',
          notes: '',
          one: '$16,000.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00'
        },
        {
          value: false,
          name: 'Machine Learning Advisors & Data Exploration ',
          notes: '',
          one: '$210,000.00',
          two: '$360,000.00',
          three: '$360,000.00',
          four: '$480,000.00',
          five: '$480,000.00'
        },
        {
          value: false,
          name: 'Tech Audit Reports & Expert Validation (Cryptography)',
          notes: '',
          one: '$0.00',
          two: '$200,000.00',
          three: '$200,000.00',
          four: '$0.00',
          five: '$0.00'
        },
        {
          value: false,
          name: 'Application Prototyping',
          notes: '',
          one: '$55,000.00',
          two: '$60,000.00',
          three: '$60,000.00',
          four: '$60,000.00',
          five: '$60,000.00'
        },
        {
          value: false,
          name: 'App (UI/UX), web redesign & progressive app development',
          notes: '',
          one: '$241,000.00',
          two: '$120,000.00',
          three: '$120,000.00',
          four: '$120,000.00',
          five: '$120,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$966,000.00',
          two: '$1,002,000.00',
          three: '$1,002,000.00',
          four: '$922,000.00',
          five: '$922,000.00'
        }
      ],
      // Reg compliance and legal
      timercl: [
        {
          value: false,
          name: 'Token Sale Infastructure & Preperation',
          notes: '',
          one: '$30,000.00',
          two: '$60,000.00',
          three: '$60,000.00',
          four: '$0.00',
          five: '$0.00'
        },
        {
          value: false,
          name: 'Legal Compliance (Website, OM, White Paper)',
          notes: '',
          one: '$96,500.00',
          two: '$80,000.00',
          three: '$60,000.00',
          four: '$80,000.00',
          five: '$60,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$126,500.00',
          two: '$140,000.00',
          three: '$120,000.00',
          four: '$80,000.00',
          five: '$60,000.00'
        }
      ],
      //Management and Admin
      timemna: [
        {
          value: false,
          name: 'Administrative & Project Management Salaries',
          notes: '',
          one: '$30,000.00',
          two: '$42,000.00',
          three: '$66,000.00',
          four: '$102,000.00',
          five: '$138,000.00'
        },
        {
          value: false,
          name: 'Office/R&D Center',
          notes: '',
          one: '$42,000.00',
          two: '$42,000.00',
          three: '$60,000.00',
          four: '$120,000.00',
          five: '$120,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$72,000.00',
          two: '$84,000.00',
          three: '$126,000.00',
          four: '$222,000.00',
          five: '$258,000.00'
        }
      ],
      //Service and Supply Reserve Cost
      timessr: [
        {
          value: false,
          name: 'Services & Supplies',
          notes: '',
          one: '$60,000.00',
          two: '$60,000.00',
          three: '$70,000.00',
          four: '$70,000.00',
          five: '$70,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$60,000.00',
          two: '$60,000.00',
          three: '$70,000.00',
          four: '$70,000.00',
          five: '$70,000.00'
        }
      ],
      // Total Cost 
      totalCost: [
        {
          value: false,
          name: '',
          notes: '',
          one: '$2,591,660.00',
          two: '$2,451,176.00',
          three: '$2,524,993.60',
          four: '$2,546,992.96',
          five: '$2,613,592.26'
        }
      ],
      //Total with Contingency
      totalCostCont: [
        {
          value: false,
          name: '',
          notes: '',
          one: '$2,850,826.00',
          two: '$2,696,293.60',
          three: '$2,777,492.96',
          four: '$2,801,692.26',
          five: '$2,874,951.48'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>